import React from 'react';
import PropTypes from 'prop-types';
import {Title} from './Title';
import {List} from './List';
import {Option} from './Option';
import {Wrapper} from './Wrapper';
import {TitleBlock} from './TitleBlock';
import {ExperimentStep} from '../ExperimentStep';
import {Utilities} from '@learningblocks/exp-constants';
const {DRAG_DROP__ID} = Utilities;

import './style.scss';

export function StepOptions(props) {
  const onDragStart = (optionId) => (event) => {
    event.dataTransfer.setData(DRAG_DROP__ID, optionId);
  };

  const onSelect = (optionId) => () => props.onSetStep(optionId);

  const renderOption = (option) => {
    if (option.visible) {
      return (
        <Option onDragStart={onDragStart(option.id)} key={option.id}>
          <ExperimentStep
            tabIndex={0}
            onSelect={onSelect(option.id)}
            text={option.text}
            color={option.color}
            isEmpty={true}
          />
        </Option>
      );
    } else return null;
  };

  const className = `stepOptions ${props.className}`;

  return (
    <Wrapper className={className}>
      <TitleBlock className='stepOptions_title'>
        <Title className='stepOptions_title--title' title={props.title} />
      </TitleBlock>
      <List className='stepOptions_list'>{props.list.map(renderOption)}</List>
    </Wrapper>
  );
}

StepOptions.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Title of the Options block
   */
  title: PropTypes.string,
  /**
   * List of options
   */
  list: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of the option
       */
      id: PropTypes.number,
      /**
       * Main title text of the option
       */
      text: PropTypes.string,
      /**
       * Theme color of the option
       */
      color: PropTypes.string,
      /**
       * visibility of option
       */
      visible: PropTypes.bool,
    })
  ),
};

StepOptions.defaultProps = {
  className: '',
};
